import type { Dispatch, RefObject } from 'react';
import type { LineId } from '@shared/rfqText';
import { useArtworkWarningTexts } from '../artwork/warnings';
import { RfqStep } from '../rfq/RfqStep';
import { getContainer } from './model';
import { useClosureLabel } from './parts';
import type { StageApi } from './Stage';
import { STEP_IDS, toConfiguration, type ProductAction, type ProductState, type StepId } from './state';

const EDIT_STEP: Partial<Record<LineId, StepId>> = {
  container: 'container',
  glass: 'glass',
  artwork: 'upload',
  placement: 'editor',
  ink: 'print',
  coverage: 'print',
};

export function StepRfq({ s, dispatch, stage }: { s: ProductState; dispatch: Dispatch<ProductAction>; stage: RefObject<StageApi | null> }) {
  const warn = useArtworkWarningTexts();
  const closure = useClosureLabel();
  const c = getContainer(s.containerId);
  const warnings = s.artwork ? warn(s.artwork.warnings) : [];
  return (
    <RfqStep
      quantity={s.quantity}
      skuCount={s.skuCount}
      targetDate={s.targetDate}
      artwork={s.artwork}
      uploadedArtworkId={s.upload.id}
      buildConfiguration={(ids) => toConfiguration(s, closure(c), warnings, ids)}
      exportMockup={async () => (s.artwork ? ((await stage.current?.exportMockup(1200)) ?? null) : null)}
      onArtworkUploaded={(id) => dispatch({ type: 'upload', status: 'done', id })}
      onQuantity={(quantity) => dispatch({ type: 'quantity', quantity })}
      editable={Object.keys(EDIT_STEP) as LineId[]}
      onEdit={(line) => {
        const step = EDIT_STEP[line];
        if (step) dispatch({ type: 'goto', step: STEP_IDS.indexOf(step) });
      }}
      onReset={() => dispatch({ type: 'reset' })}
    />
  );
}
